import React from 'react'
import moment from 'moment';
import { component_tool } from '@/tool';
import { WizCallLog, WizPhoneCall } from "@/containers/common";
import './index.less'
const {
  WizTooltip,
  WizModal,
  WizInput,
  WizButton, WizRow, WizCol
} = component_tool;
import { WizTableForm } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
//配置项
let componentName = 'apply'

const columns = ({ applyName, applyId }) => [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "applyId",
    searchItem: {
      type: "hidden",
      formatInit: () => applyId || null
    }
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    searchItem: {},
    tableItem: {
      render: (text, record) => {
        return <WizTooltip className='appy-verify-text' title={text}>
          <div className='appy-verify-text' >
            {text}
          </div>
        </WizTooltip >
      }
    }
  },
  {
    title: "姓名",
    name: "fullName",
    dataIndex: "fullName",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "组织",
    name: "orgId",
    searchItem: {
      diy: WizTableForm,
      selectType: 'radio',
      ...organizationConfig,
    }
  },
  {
    title: "岗位",
    name: "positionId",
    searchItem: {
      diy: WizTableForm,
      selectType: 'radio',
      ...positionConfig,
    }
  },
  {
    title: "组织名称",
    name: "orgName",
    dataIndex: "orgName",
    tableItem: {
      render: (text, record) => {
        return <WizTooltip className='appy-verify-text' title={text}>
          <div className='appy-verify-text' >
            {text}
          </div>
        </WizTooltip >
      }
    }
  },
  {
    title: "组织编码",
    name: "orgCode",
    dataIndex: "orgCode",
    tableItem: {}
  },
  {
    title: "岗位",
    name: "positionName",
    dataIndex: "positionName",
    tableItem: {}
  },
  {
    title: "任职状态",
    name: "jobState",
    dataIndex: "jobState",
    tableItem: {},
    dict: [
      { code: 0, codeName: '离职' },
      { code: 1, codeName: '在职' }
    ]
  },
  {
    title: "报名名称",
    name: "applyName",
    dataIndex: "applyName",
    searchItem: {
      formatInit: () => applyName || null
    },
    tableItem: {
      render: (text, record) => {
        return <WizTooltip className='appy-verify-text' title={text}>
          <div className='appy-verify-text' >
            {text}
          </div>
        </WizTooltip >
      }
    }
  },
  {
    title: "计划安排名称",
    name: "planName",
    dataIndex: "planName",
    tableItem: {
      render: (text, record) => {
        return <WizTooltip className='appy-verify-text' title={text}>
          <div className='appy-verify-text' >
            {text}
          </div>
        </WizTooltip >
      }
    }
  },
  {
    title: "报名时间",
    name: "applyDate",
    dataIndex: "applyDate",
    searchItem: {
      type: 'date~',
      showTime: true,
      format: 'YYYY-MM-DD HH:mm'
    }
  },
  {
    title: "审核状态",
    name: "status",
    dataIndex: "status",
    searchItem: {
      type: 'select',
    },
    tableItem: {},
    dict: [
      { code: 1, codeName: '待审核' },
      { code: 2, codeName: '已通过' },
      { code: 3, codeName: '未通过' },
    ],
  },
  {
    title: "报名提交时间",
    name: "applySubmitTime",
    dataIndex: "applySubmitTime",
    tableItem: {
      render: (text, record) => {
        let { applySubmitTime } = record
        return <div >{moment(applySubmitTime).format('YYYY-MM-DD HH:mm')}</div>
      }
    }
  },
  {
    title: "申请人账号",
    name: "applicantUserName",
    dataIndex: "applicantUserName",
    tableItem: {
      render: (text, record) => {
        return <WizTooltip className='appy-verify-text' title={text}>
          <div className='appy-verify-text' >
            {text}
          </div>
        </WizTooltip >
      }
    }
  },

  {
    title: "申请人姓名",
    name: "applicantFullName",
    dataIndex: "applicantFullName",
    tableItem: {}
  },
  {
    title: "报名时间",
    name: "applyDate",
    dataIndex: "applyDate",
    tableItem: {
      width: 330,
      render: (text, record) => {
        let { applyStartTime, applyEndTime } = record
        let value = moment(applyStartTime).format('YYYY-MM-DD HH:mm') + ' ~ ' + moment(applyEndTime).format('YYYY-MM-DD HH:mm')
        return <div >{value}</div>
      }
    }
  },
  {
    title: "是否已联系",
    name: "yuntelState",
    dataIndex: "yuntelState",
    formItem: {},
    searchItem: {
      type: 'select',
    },
    tableItem: {},
    dict: [
      { code: 0, codeName: "未联系" },
      { code: 1, codeName: "已联系" },
    ],
  },
];

this.auditApplyInfo = (status, onDo, e) => {
  let { record, text } = onDo.state
  let auditCmds = []
  record && record.length && record.forEach(e => {
    let auditCmd = { id: e.id, applyRecordId: e.applyRecordId, auditInfo: text, status: status }
    auditCmds.push(auditCmd)
  })
  onDo.doAction({
    path: 'applyAudit/batchAudit',
    payload: {
      key: 'applyAudit@batchAudit',
      apiParams: {
        auditCmds: auditCmds
      }
    }
  })
}
const templateConfig = ({ look, onDo, params }) => {
  let applyId = params && params.applyId ? params.applyId : null
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(params),
        searchBarProps: {
          dataFormat: (val) => {
            let { applyDate } = val
            if (applyDate && applyDate.length) {
              if (applyDate[0]) {
                val['applyStartTime'] = moment(applyDate[0]).format("YYYY-MM-DD HH:mm")
              }
              if (applyDate[1]) {
                val['applyEndTime'] = moment(applyDate[1]).format("YYYY-MM-DD HH:mm")
              }
            } else {
              val['applyStartTime'] = undefined;
              val['applyEndTime'] = undefined;
            }
            // delete val['applyDate']
            return val
          },
          buttonSort: ['review', 'batchReview', 'exportApplication', 'callLog'],
          buttons: [
            {
              key: 'review',
              custom: true,
              params: { children: '审核', type: 'primary' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/workflow/applyVerify/verify',
                  record: {applyId: applyId}
                },
              },
              needSelect: true
            },
            {
              key: 'batchReview',
              custom: true,
              params: { children: '批量审核' },
              customOnClick: {
                key: 'modal',
                params: {
                  modalParams: {
                    title: '报名批量审核',
                    destroyOnClose: true,
                    footer: null,
                    diy: (e) => {
                      onDo.changeModal = e.changeModal
                      let record = e && e.rows
                      onDo.setState({ record: record })
                      return <>
                        <div align='center'>
                          <WizRow>
                            <WizCol span={4}>审核意见：</WizCol>
                            <WizCol span={15}>
                              <WizInput.TextArea rows={4} onChange={(e) => { onDo.setState({ text: e.target.value }) }} />
                            </WizCol>
                          </WizRow>
                          <WizRow>
                            <WizCol style={{ marginTop: 15 }} span={4}>审核结果：</WizCol>
                            <WizCol style={{ marginTop: 15 }} span={15}>
                              <WizButton style={{ marginRight: 20 }} type='primary' onClick={() => { this.auditApplyInfo(2, onDo, e) }}>通过</WizButton>
                              <WizButton type='danger' onClick={() => { this.auditApplyInfo(3, onDo, e) }}>未通过</WizButton>
                            </WizCol>
                          </WizRow>
                        </div>
                      </>
                    },
                    onOk: () => {
                    },
                    onCancel: () => {
                    }
                  }
                }
              },
              needSelect: true
            },
            {
              key: 'exportApplication',
              custom: true,
              params: { icon: 'export', children: '导出报名申请', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
          needOnRowSelect: (record, index) => {
            return record['status'] === 1
          },
          rowSelection: {
            getCheckboxProps: (record) => {
              return { disabled: record['status'] !== 1 }
            }
          }
        },
        rowOperateProps: {
          width: 250,
          fixed: 'right',
        },
        rowOperateSort: ['delete', 'look', 'viewJobs', 'phoneCall', 'callLog'],
        rowOperateView: [
          {
            key: 'delete',
            custom: true,
            params: { children: '删除' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'delete',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                WizModal.confirm({
                  title: '注意',
                  content: '删除后数据不可恢复，您确定要删除选中的报名记录吗？',
                  onOk: () => {
                    callback && callback({ ids: [record.id] })
                  },
                  onCancel() { }
                })
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return { disabled: record.status === 2 }
            }
          },
          {
            key: 'look',
            name: 'WizButton',
            params: {
              children: '查看',
              key: 'look',
            },
            onClick: (e) => { look && look(e['record'],applyId) }
          },
          {
            key: "viewJobs",
            custom: true,
            params: { children: "查看任职" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/personalCert/personalCertList/lookPositionInfo"
              }
            }
          },
          {
            key: 'phoneCall',
            name: 'WizButton',
            params: {
              children: '拨打电话',
              key: 'phoneCall',
            },
            onClick: (e) => { onDo.openCall && onDo.openCall(e['record']) }
          },
          {
            key: 'callLog',
            name: 'WizButton',
            params: {
              children: '通话记录',
              key: 'callLog',
            },
            onClick: (e) => { onDo.openCallLog && onDo.openCallLog(e['record']) }
          },
        ]
      }
    }
  }
};

const apis = (params = {}) => {
  return {
    list: {
      path: `${componentName}/verifyList`,
      payload: {
        key: `${componentName}@verifyList`,
        apiParams: { pageNum: 1, pageSize: 10, status: 1, ...(params || {}) }
      }
    },
    delete: {
      path: `${componentName}/verifyDelete`,
      payload: {
        key: `${componentName}@verifyDelete`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/exportVerify`,
      payload: {
        key: `${componentName}@exportVerify`,
        apiParams: { status: 1, ...(params || {}) }
      }
    },
    batchAudit: {
      path: `applyAudit/batchAudit`,
      payload: {
        key: `applyAudit@batchAudit`,
        apiParams: {}
      }
    },
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis: apis(args['params']),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
